import { render, staticRenderFns } from "./FactorsList.vue?vue&type=template&id=6e6d6cd9&scoped=true"
import script from "./FactorsList.vue?vue&type=script&lang=js"
export * from "./FactorsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6d6cd9",
  null
  
)

export default component.exports